import React from 'react';

const ProductsPage = () => {
  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Products</h1>
      <div className="bg-white shadow rounded-lg p-6">
        <p className="text-gray-600">Product management coming soon...</p>
      </div>
    </div>
  );
};

export default ProductsPage;